/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MstTransportType
 */
export interface MstTransportType {
    /**
     * 
     * @type {number}
     * @memberof MstTransportType
     */
    transportTypeId: number | null;
    /**
     * 
     * @type {number}
     * @memberof MstTransportType
     */
    companyId: number | null;
    /**
     * 
     * @type {string}
     * @memberof MstTransportType
     */
    transportTypeName: string | null;
    /**
     * 
     * @type {number}
     * @memberof MstTransportType
     */
    maxWeight: number | null;
    /**
     * 
     * @type {number}
     * @memberof MstTransportType
     */
    maxPalletCount: number | null;
    /**
     * 
     * @type {string}
     * @memberof MstTransportType
     */
    remarks: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MstTransportType
     */
    insertDatetime: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof MstTransportType
     */
    updateDatetime: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstTransportType
     */
    insertUser: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstTransportType
     */
    updateUser: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MstTransportType
     */
    deleteDatetime: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstTransportType
     */
    deleteUser: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstTransportType
     */
    deleteFlg: boolean | null;
}

/**
 * Check if a given object implements the MstTransportType interface.
 */
export function instanceOfMstTransportType(value: object): value is MstTransportType {
    if (!('transportTypeId' in value) || value['transportTypeId'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('transportTypeName' in value) || value['transportTypeName'] === undefined) return false;
    if (!('maxWeight' in value) || value['maxWeight'] === undefined) return false;
    if (!('maxPalletCount' in value) || value['maxPalletCount'] === undefined) return false;
    if (!('remarks' in value) || value['remarks'] === undefined) return false;
    if (!('insertDatetime' in value) || value['insertDatetime'] === undefined) return false;
    if (!('updateDatetime' in value) || value['updateDatetime'] === undefined) return false;
    if (!('insertUser' in value) || value['insertUser'] === undefined) return false;
    if (!('updateUser' in value) || value['updateUser'] === undefined) return false;
    if (!('deleteDatetime' in value) || value['deleteDatetime'] === undefined) return false;
    if (!('deleteUser' in value) || value['deleteUser'] === undefined) return false;
    if (!('deleteFlg' in value) || value['deleteFlg'] === undefined) return false;
    return true;
}

export function MstTransportTypeFromJSON(json: any): MstTransportType {
    return MstTransportTypeFromJSONTyped(json, false);
}

export function MstTransportTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): MstTransportType {
    if (json == null) {
        return json;
    }
    return {
        
        'transportTypeId': json['transport_type_id'],
        'companyId': json['company_id'],
        'transportTypeName': json['transport_type_name'],
        'maxWeight': json['max_weight'],
        'maxPalletCount': json['max_pallet_count'],
        'remarks': json['remarks'],
        'insertDatetime': (json['insert_datetime'] == null ? null : new Date(json['insert_datetime'])),
        'updateDatetime': (json['update_datetime'] == null ? null : new Date(json['update_datetime'])),
        'insertUser': json['insert_user'],
        'updateUser': json['update_user'],
        'deleteDatetime': (json['delete_datetime'] == null ? null : new Date(json['delete_datetime'])),
        'deleteUser': json['delete_user'],
        'deleteFlg': json['delete_flg'],
    };
}

export function MstTransportTypeToJSON(json: any): MstTransportType {
    return MstTransportTypeToJSONTyped(json, false);
}

export function MstTransportTypeToJSONTyped(value?: MstTransportType | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'transport_type_id': value['transportTypeId'],
        'company_id': value['companyId'],
        'transport_type_name': value['transportTypeName'],
        'max_weight': value['maxWeight'],
        'max_pallet_count': value['maxPalletCount'],
        'remarks': value['remarks'],
        'insert_datetime': value['insertDatetime'] == null ? value['insertDatetime'] : value['insertDatetime'].toISOString(),
        'update_datetime': value['updateDatetime'] == null ? value['updateDatetime'] : value['updateDatetime'].toISOString(),
        'insert_user': value['insertUser'],
        'update_user': value['updateUser'],
        'delete_datetime': value['deleteDatetime'] == null ? value['deleteDatetime'] : value['deleteDatetime'].toISOString(),
        'delete_user': value['deleteUser'],
        'delete_flg': value['deleteFlg'],
    };
}

